import { Avatar, Box, Stack, Typography } from "@mui/material"
import NumberFunctions from "../../../../../core/functions/NumberFunctions"
import { QuantityPicker } from "../../../../Inputs/QuantityPicker"

interface DetailProductItem7Props {
  productImageUrl?: string | null
  productName?: string
  value?: number | null
  isMainProduct: boolean
  isAllowChooseQuantity: boolean
  quantityValue: number
  setQuantity?: (value: number) => void
}

const DetailProductItem7 = ({
  productImageUrl,
  productName,
  value,
  isMainProduct,
  isAllowChooseQuantity,
  quantityValue,
  setQuantity,
}: DetailProductItem7Props) => {
  return (
    <Stack
      direction="row"
      spacing={2}
      alignContent="center"
      alignItems="center"
      width="100%"
      sx={{ px: 1, py: 0.5 }}
    >
      <Box sx={{ height: 80, width: 80 }}>
        {productImageUrl && productImageUrl !== "" && (
          <img
            src={productImageUrl}
            alt={productName}
            style={{
              height: 80,
              width: 80,
              objectFit: "cover",
              borderRadius: "8px",
            }}
          />
        )}
      </Box>
      <Stack
        direction="row"
        spacing={2}
        alignContent="center"
        justifyContent="space-between"
        width="100%"
      >
        <Box gap="16px">
          <Typography
            color="#343948"
            fontSize={{ xs: "14px", sm: "16px" }}
            lineHeight={{ xs: "18px", sm: "20px" }}
          >
            {productName}
          </Typography>
        </Box>
        <Stack
          direction="column"
          spacing={1}
          alignContent="end"
          alignItems="end"
        >
          <Typography
            fontWeight={600}
            sx={{ fontSize: "16px", lineHeight: "18px" }}
          >
            {NumberFunctions.formatMoneyDefault(value)}
          </Typography>
          {!isMainProduct && (
            <Avatar
              sx={{
                bgcolor: "#fbfbfb",
                border: "1px solid #DCDDDE",
                color: "#000000",
                fontWeight: 600,
                width: 50,
                height: 50,
              }}
            >
              {quantityValue}
            </Avatar>
          )}
          {isMainProduct && isAllowChooseQuantity && (
            <Box>
              <QuantityPicker
                value={quantityValue}
                onChange={(next) => setQuantity?.(next)}
                min={1}
                size="md"
              />
            </Box>
          )}
        </Stack>
      </Stack>
    </Stack>
  )
}

export default DetailProductItem7
